const shared = {
  // ...Folders...
  label: require("./label"),
  notifications: require("./notifications"),
  // ...Files...
  author: require("./author"),
  categories: require("./categories"),
  charset: require("./charset"),
  cleanAndSafe: require("./cleanAndSafe"),
  description: require("./description"),
  dictionary: require("./dictionary.index"),
  dir: require("./dir"),
  display: require("./display"),
  elementId: require("./elementId"),
  email: require("./email"),
  font: require("./font"),
  googleTagManagerId: require("./googleTagManagerId"),
  hashtagConfig: require("./hashtagConfig"),
  keywords: require("./keywords"),
  lang: require("./lang"),
  log: require("./log"),
  name: require("./name"),
  orientation: require("./orientation"),
  origin: require("./origin"),
  path: require("./path"),
  port: require("./port"),
  regex: require("./regex"),
  resource: require("./resource"),
  settings: require("./settings"),
  socialMedia: require("./socialMedia"),
  storyCategories: require("./storyCategories"),
  storyCategory: require("./storyCategory"),
  storyLength: require("./storyLength"),
  style: require("./style"),
  tokenExpiration: require("./tokenExpiration"),
  topFilterConfigs: require("./topFilterConfigs"),
  twitter: require("./twitter"),
  type: require("./type"),
  url: require("./url"),
  validate: require("./validate"),
  viewport: require("./viewport"),
};

module.exports = shared;
